import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import VerticalBarChart from "../../../ceo/analysis/competitive/charts/vertical-bar";

class TeamReportsSection2Step9 extends PureComponent {
  get GrossMargins() {
    const { teams, competition_metrics } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value:
          competition_metrics[team_id] &&
          competition_metrics[team_id]["GrossMargins"]
            ? competition_metrics[team_id]["GrossMargins"] * 100
            : 0
      });
    });

    return data;
  }

  get left_content() {
    return (
      <span>
        Gross Margins is a percentage that measures the spread between the
        revenues that you generated from selling a product with the cost of
        producing that product.
        <br />
        <br />
        For example, if Apple generates a total of $100 in sales from selling
        the iPhone, but it cost Apple $30 to produce the iPhone, then iPhone's
        gross margin would be 70% (i.e. $100 - $30) / $100.
        <br />
        <br />
        <div className="formula">
          GROSS MARGINS =
          <div className="formula">
            REVENUES - COST OF SALES
            <hr />
            REVENUES
          </div>
        </div>
      </span>
    );
  }

  get right_content() {
    return (
      <div className="team-reports-valign-center">
        <VerticalBarChart suffix="%" data={this.GrossMargins} />
        <div className="text-center" style={{ marginTop: "-20px" }}>
          Gross Margins
        </div>
      </div>
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Gross Margins"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection2Step9;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-2/step-9.js